<template>
    <v-card
            color="transparent"
            flat
    >
        <v-layout justify-center align-center text-left>

            <div class="text-center pa-4">
                <v-avatar size="65" class="ma-0" color="grey lighten-2">
                    <img v-if="institution.settings && institution.settings.avatar_image" :src="institution.settings.avatar_image" />
                    <v-icon v-else color="grey">fas fa-building</v-icon>
                </v-avatar>
            </div>

            <v-flex xs12 sm10 lg11>
                <v-card-title primary-title>
                    <v-flex xs12 class="headline institution-name" @click="onClickName(institution)">
                        {{institution.name}}
                    </v-flex>
                        <v-rating
                                v-if="ratings && stars"
                                readonly
                                v-model="stars"
                                background-color="secondary"
                                color="accent"
                                dense
                                half-increments
                                empty-icon="$vuetify.icons.ratingFull"
                                hover
                                size="18"
                        ></v-rating>
                        <span v-if="ratings && stars" class="primary--text text--darken-2 caption ml-2">
                            ({{ stars }} / {{institution.ratings_summary.count}})
                        </span>
                </v-card-title>
            </v-flex>

        </v-layout>

    </v-card>

</template>
<script>
    export default{
        props: ['institution', 'toProfile','ratings'],
        methods:{
            onClickName(entity){
                var vm = this
                vm.$emit('click-name', entity)
                if(typeof vm.toProfile != 'undefined'){
                    vm.$router.push({
                      name: 'provider.profile',
                      params: {
                        id: vm.toProfile
                      }
                    })
                }
            }
        },
        computed:{
            stars(){
                var vm = this

                if(!vm.institution || !vm.institution.ratings_summary || !vm.institution.ratings_summary.avg){
                    return null
                }

                return Math.round(vm.institution.ratings_summary.avg * 100) / 100

            },
            starsColor(){
                return this.stars < 3 ? 'accent lighten-2' : 'yellow accent-4'
            }
        }
    }
</script>

<style scoped>

    .institution-name{
        cursor: pointer;
    }

    .institution-name:hover{
        color: #3192ff;
    }

    >>>.v-list__tile.v-list__tile--avatar.theme--dark{
        padding:0
    }

    >>>.institution-item-content{
        height: 100px
    }
</style>
